// extracted by mini-css-extract-plugin
export default {"content":"styles_content__8db+Z","title":"styles_title__9xdkP","button":"styles_button__RGbpO"};